var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



// WEBPACK FOOTER //
// ../lodash/_nativeCreate.js